import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.css']
})
export class FeaturesComponent implements OnInit {

  titleSectionProp: any = {
    title: 'Te conectamos con las mejores propuestas en formación para impulsar tu desarrollo profesional.',
    description: 'Beneficios para potenciar tu perfil en la industria y especialización del puesto que quieras alcanzar'
  };

  List : any[] = [
    {
      title: 'Todas las industrias y especializaciones',
      icon: 'flaticon flaticon-growth',
      hoverClass: 'purple-hover',
      desc: 'La demanda existe en todas las industrias. Mejorá en lo que te apasiona.'
    },
    {
      title: 'Instituciones educativas de primer nivel',
      icon: 'flaticon flaticon-professional',
      hoverClass: 'purple-hover',
      desc: 'Formación laboral de valor. Con certificaciones nacionales e internacionales.'
    }
  ]
  
  constructor() { }

  ngOnInit(): void {
  }

}
